<script setup>
const props = defineProps({
    to: {
        type: [String, Object],
        default: undefined
    },
    href: {
        type: String,
        default: undefined
    },
    tag: {
        type: String,
        default: 'button'
    }
});

const { theme } = useTheme();
const isHovered = ref(false);

const component = computed(() => {
    if (props.to) return resolveComponent('NuxtLink');
    if (props.href) return 'a';
    return props.tag;
});

const buttonStyle = computed(() => {
    return isHovered.value
        ? { backgroundColor: theme.value.medium, borderColor: theme.value.medium, color: theme.value.buttonText }
        : { backgroundColor: 'transparent', borderColor: theme.value.medium, color: theme.value.outlineButtonText };
});
</script>

<template>
    <component
        :is="component"
        :to="to"
        :href="href"
        class="inline-block whitespace-nowrap py-2 px-4 rounded-3xl text-sm transition-all duration-150 transform border cursor-pointer"
        :style="buttonStyle"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
    >
        <slot></slot>
    </component>
</template>
